<template>
    <div class="be-wrapper be-fixed-sidebar" :class="{ 'be-color-header': isHeidilandSystem }">
        <be-top-header/>
        <be-left-sidebar/>
        <div :class="{ 'be-content': true, 'be-no-padding': !!$slots.default && noPadding, 'be-aside': !!$slots.aside }">

            <div class="page-aside" v-if="!!$slots.aside">
                <div class="be-scroller-aside ps">
                    <div class="aside-content">
                        <div class="content">
                            <div class="aside-header">
                                <button :class="{ 'navbar-toggle' : true, collapsed: !showAside }" type="button" @click="showAside = !showAside">
                                    <span class="icon mdi mdi-caret-down"></span>
                                </button>
                                <span class="title">{{ title }}</span>
                                <p class="description" v-if="description">{{ description }}</p>
                            </div>
                        </div>
                        <div :class="{ 'aside-nav collapse': true, show: showAside }">
                            <slot name="aside"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="page-head" v-if="(title || !!$slots['page-head']) && !$slots.aside">
                <slot name="page-head">
                    <h2 class="page-head-title">{{ title }}</h2>
                    <p class="page-head-description" v-if="description">{{ description }}</p>
                </slot>
            </div>

            <div class="main-content container-fluid">
                <slot><div class="splash-card centered"><be-spinner/></div></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import env from '../../mixins/env';

    export default {
        mixins: [env],

        props: {
            title: String,
            description: String,
            noPadding: Boolean,
        },

        data: () => ({
            showAside: false,
        }),

        computed: {
            ...mapGetters('user', ['isAuthenticated']),
        },

        watch: {
            $route() {
                this.showAside = false;
            },
        },
    };
</script>
